import React from 'react'

const Footer = () => {
  return (
    <footer className=' bg-slate-200'>
      <div className='container mx-auto p-4'>
      <p className='text-center font-bold'>Copyright © 2024 Subhodip Shee | All Rights Reserved</p>
      </div>
    </footer>
  )
}

export default Footer
